import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { App } from "./App";
import LanguageProvider from "./Context/changeLanguageProvider";
import ErrorBoundary from "./Context/ErrorHandler";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
  <Router>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </Router>
  </ErrorBoundary>
);
